export const DASHBOARD = '/';
export const LOGIN = '/login';
export const RESPONDENT_LIST = '/respondent-list';
export const USER_PROFILE = '/profile';

export const PROJECT_LIST = '/projects';
export const SINGLE_PROJECT = '/projects/:id';
